"use strict";
// THIS FILE IS AUTO-GENERATED BY THE ANALYTICS CODEGEN SCRIPT
// DO NOT MANUALLY MODIFY THIS FILE
// FOR MORE INFORMATION CHECK OUT: https://github.com/flexapp/genoa/pull/5762
exports.__esModule = true;
exports.CustomerCookieConsentSelectedAnalyticsEvent = exports.CustomerCookieConsentInitializedAnalyticsEvent = void 0;
var util_1 = require("./util");
/**
 * Fired when the Cookie Consent Management library has been successfully initialized in the user's Web Browser
 */
var CustomerCookieConsentInitializedAnalyticsEvent = (0, util_1.newAnalyticsEventWithOptionalPropertiesFactory)('customer_cookie_consent_initialized');
exports.CustomerCookieConsentInitializedAnalyticsEvent = CustomerCookieConsentInitializedAnalyticsEvent;
/**
 * Fired when the Cookie Consent Management library reports an update to the user's cookie consent
 */
var CustomerCookieConsentSelectedAnalyticsEvent = (0, util_1.newAnalyticsEventWithOptionalPropertiesFactory)('customer_cookie_consent_selected');
exports.CustomerCookieConsentSelectedAnalyticsEvent = CustomerCookieConsentSelectedAnalyticsEvent;
